export enum MaptycsApplication {
    CLAIMS = 'CLAIMS',
    LOCATIONS = 'LOCATIONS',
    POLICIES = 'POLICIES',
    MEMBERS = 'MEMBERS',
    BCS_LOCATIONS = 'BCS_LOCATIONS',
    BCS_VENDORS = 'BCS_VENDORS',
    BCS_TENANTS = 'BCS_TENANT'
}
